var AVM1PropertyDescriptor = /** @class */ (function () {
    function AVM1PropertyDescriptor(flags, value, get, set, watcher) {
        this.flags = flags;
        this.value = value;
        this.get = get;
        this.set = set;
        this.watcher = watcher;
        // Empty block
    }
    return AVM1PropertyDescriptor;
}());
export { AVM1PropertyDescriptor };
